/** @internal */
export const OP_STATE_PENDING = "Pending";
/** @internal */
export const OP_STATE_DONE = "Done";
//# sourceMappingURL=deferred.js.map